module.exports = __webpack_public_path__ + "img/BNB.55ff74b5.svg";